import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { findUserHistories, getDetailInUserHistory } from "services/UserHistoryService";
import { X_TOTAL_COUNT } from "utils/constants";
import { checkDateMonth, dateFormat1, dateFormat2, formatDate, range2 } from "utils/date";
import { handleError } from "utils/handleError";
import { AccountRegisterHistoryContext } from "./AccountRegisterHistoryContext";
import AccountRegisterHistoryDetail from "./AccountRegisterHistoryDetail";

export const AccountRegisterHistoryList = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["account-register-history", "common", "user"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const accountRegisterHistoryContext = useContext(AccountRegisterHistoryContext);
    const { accountRegisterHistories, setAccountRegisterHistories, accountRegisterHistoryDialog, setAccountRegisterHistoryDialog, accountRegisterHistoryDetails, setAccountRegisterHistoryDetails } = accountRegisterHistoryContext;

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [checkLoad, setCheckLoad] = useState(false);

    const now = new Date();

    const beforeNow = new Date(new Date().setDate(new Date().getDate() - range2));

    const [formatDateVal, setFormatDateVal] = useState(dateFormat1);

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            userName: { value: "", matchMode: "contains" },
            fullName: { value: "", matchMode: "contains" },
            email: { value: null, matchMode: "contains" },
            time: { value: null, matchMode: "equals" },
            phoneNumber: { value: "", matchMode: "contains" },
            fromDate: { value: beforeNow, matchMode: "equals" },
            toDate: { value: now, matchMode: "equals" },
        },
    });

    const states = [
        { label: t("user.-1", { ns: "user" }), value: -1 },
        { label: t("user.0", { ns: "user" }), value: 0 },
        { label: t("user.1", { ns: "user" }), value: 1 },
        { label: t("user.2", { ns: "user" }), value: 2 },
        { label: t("user.3", { ns: "user" }), value: 3 },
        { label: t("user.4", { ns: "user" }), value: 4 },
        { label: t("user.31", { ns: "user" }), value: 31 },
        { label: t("user.97", { ns: "user" }), value: 97 },
        { label: t("user.98", { ns: "user" }), value: 98 },
        { label: t("user.99", { ns: "user" }), value: 99 },
    ];

    const types = [
        { label: "Công dân", value: "CITIZEN" },
        { label: "Người nước ngoài", value: "FOREIGN" },
    ];
    useEffect(() => {
        if (checkLoad) {
            loadLazyData();
            setCheckLoad(false);
        }
    }, [lazyParams]);

    const convertValueStatus = (level, isUpdate, state) => {
        let text = "";
        if (level == 0 && state == 0) {
            text = "Tài khoản hoạt động ở mức 0";
        } else if (level == 1 && state == 1 && isUpdate == false) {
            text = "Tài khoản chờ kích hoạt thiết bị - Trường hợp cần đổi mật khẩu";
        } else if (level == 1 && state == 1 && isUpdate == true) {
            text = "Tài khoản chờ kích hoạt thiết bị - Trường hợp không cần đổi mật khẩu";
        } else if (level == 1 && state == 2) {
            text = "Tài khoản hoạt động mức 1";
        } else if (level == 1 && state == 97) {
            text = "Tài khoản bị khóa tạm thời";
        } else if (level == 1 && state == 98) {
            text = "Tài khoản bị khóa tạm thời";
        } else if (level == 2 && state == 1 && isUpdate == false) {
            text = "Tài khoản chờ kích hoạt thiết bị - Trường hợp cần đổi mật khẩu";
        } else if (level == 2 && state == 1 && isUpdate == true) {
            text = "Tài khoản chờ kích hoạt thiết bị - Trường hợp không cần đổi mật khẩu";
        } else if (level == 2 && state == 2) {
            text = "Tài khoản hoạt động mức 2";
        } else if (level == 2 && state == 97) {
            text = "Tài khoản bị khóa tạm thời";
        } else if (level == 2 && state == 98) {
            text = "Tài khoản bị khóa vĩnh viễn";
        }
        return text;
    };

    const loadLazyData = () => {
        setLoading(true);
        findUserHistories(headers, lazyParams)
            .then((res) => {
                setTotalRecords(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParams.rows * lazyParams.page + 1 + i;
                    if (e.detail) {
                        e.details = Object.entries(JSON.parse(e.detail)).map((x, y) => {
                            let before = x[1]["before"];
                            let after = x[1]["after"];
                            let field = x[0];
                            if (x[0] == "state") {
                                field = "status";
                                before = convertValueStatus(e.level, e.isUpdate, before);
                                after = convertValueStatus(e.level.isUpdate, after);
                            } else if (x[0] == "isUpdate") {
                                field = "status";
                                before = convertValueStatus(e.level, before, e.state);
                                after = convertValueStatus(e.level, after, e.state);
                            } else {
                                field = x[0];
                            }

                            return { stt: y + 1, field: field, valueBefore: before.toString(), valueAfter: after?.toString() };
                        });
                    } else {
                        e.details = [];
                    }
                });
                setAccountRegisterHistories(dataRes);
            })
            .catch((error) => handleError(toast, t, error))
            .finally(() => setLoading(false));
    };

    const onPage = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onSort = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onFilter = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        _lazyParams["first"] = 0;
        setLazyParams(_lazyParams);
    };

    const textFilterTemplate = (options) => {
        return (
            <div className="flex align-items-center justify-content-center">
                <InputText value={options.value} onChange={(e) => options.filterApplyCallback(e.target?.value || "")} />
            </div>
        );
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const searchOption = (
        <div className="grid">
            <div className="col-12">
                <div className="grid">
                    {/* tên đăng nhập */}
                    <div className="col-4">
                        <div className="grid custom-form">
                            <label
                                className="col-fixed text-center"
                                style={{
                                    width: "114px",
                                    justifyContent: "end",
                                    display: "flex",
                                    padding: "0.75rem 0px 0px 0px",
                                }}
                                htmlFor="userName"
                            >
                                {t("history.userName")}
                            </label>
                            <div className="col">
                                <InputText
                                    style={{
                                        width: "100%",
                                    }}
                                    id="userName"
                                    name="userName"
                                    onChange={(e) => {
                                        setLazyParams({
                                            ...lazyParams,
                                            filters: {
                                                ...lazyParams.filters,
                                                userName: {
                                                    ...lazyParams.filters.userName,
                                                    value: e.target.value,
                                                },
                                            },
                                        });
                                    }}
                                ></InputText>
                            </div>
                        </div>
                    </div>

                    {/* số điện thoại */}
                    <div className="col-4">
                        <div className="grid custom-form">
                            <label
                                className="col-fixed text-center"
                                style={{
                                    width: "104px",
                                    justifyContent: "end",
                                    display: "flex",
                                    padding: "0.75rem 0px 0px 0px",
                                }}
                                htmlFor="phoneNumber"
                            >
                                {t("history.phoneNumber")}
                            </label>
                            <div className="col">
                                <InputText
                                    style={{
                                        width: "100%",
                                    }}
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    onChange={(e) => {
                                        setLazyParams({
                                            ...lazyParams,
                                            filters: {
                                                ...lazyParams.filters,
                                                phoneNumber: {
                                                    ...lazyParams.filters.phoneNumber,
                                                    value: e.target.value,
                                                },
                                            },
                                        });
                                    }}
                                ></InputText>
                            </div>
                        </div>
                    </div>

                    {/* email */}
                    <div className="col-4">
                        <div className="grid custom-form">
                            <label
                                className="col-fixed text-center"
                                style={{
                                    width: "49px",
                                    justifyContent: "end",
                                    display: "flex",
                                    padding: "0.75rem 0px 0px 0px",
                                }}
                                htmlFor="email"
                            >
                                {t("history.email")}
                            </label>
                            <div className="col">
                                <InputText
                                    style={{
                                        width: "100%",
                                    }}
                                    id="email"
                                    name="email"
                                    type="email"
                                    onChange={(e) => {
                                        setLazyParams({
                                            ...lazyParams,
                                            filters: {
                                                ...lazyParams.filters,
                                                email: {
                                                    ...lazyParams.filters.email,
                                                    value: e.target.value,
                                                },
                                            },
                                        });
                                    }}
                                ></InputText>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    {/* Ngày nhận từ */}
                    <div className="col-12 md:col-4">
                        <div className="grid custom-form">
                            <label
                                className="col-fixed text-center"
                                style={{
                                    width: "73px",
                                    justifyContent: "end",
                                    display: "flex",
                                    padding: "0.75rem 0px 0px 0px",
                                }}
                                htmlFor="fromDate"
                            >
                                {t("history.fromDate")}
                            </label>
                            <div className="col">
                                <Calendar
                                    style={{ width: "100%" }}
                                    value={lazyParams.filters.fromDate.value}
                                    onChange={(e) => {
                                        setLazyParams({
                                            ...lazyParams,
                                            filters: {
                                                ...lazyParams.filters,
                                                fromDate: {
                                                    ...lazyParams.filters.fromDate,
                                                    value: e.value,
                                                },
                                            },
                                        });
                                    }}
                                    onBlur={() => {
                                        setFormatDateVal(dateFormat1);
                                    }}
                                    onFocus={() => {
                                        setFormatDateVal(dateFormat2);
                                    }}
                                    name="fromDate"
                                    id="fromDate"
                                    maxDate={lazyParams.filters.toDate.value}
                                    dateFormat={formatDateVal}
                                ></Calendar>
                                {/* <InputText
                                    style={{
                                        width: "100%",
                                    }}
                                    type="date"
                                    id="fromDate"
                                    name="fromDate"
                                    value={lazyParams.filters.fromDate.value}
                                    max={lazyParams.filters.toDate.value}
                                    onChange={(e) => {
                                        setCheckLoad(false);
                                        setLazyParams({
                                            ...lazyParams,
                                            filters: {
                                                ...lazyParams.filters,
                                                fromDate: {
                                                    ...lazyParams.filters.fromDate,
                                                    value: e.target.value,
                                                },
                                            },
                                        });
                                    }}
                                ></InputText> */}
                            </div>
                        </div>
                    </div>

                    {/* đến */}
                    <div className="col-12 md:col-4">
                        <div className="grid custom-form">
                            <label
                                className="col-fixed text-center"
                                style={{
                                    width: "85px",
                                    justifyContent: "end",
                                    display: "flex",
                                    padding: "0.75rem 0px 0px 0px",
                                }}
                                htmlFor="toDate"
                            >
                                {t("history.toDate")}
                            </label>
                            <div className="col">
                                <Calendar
                                    style={{ width: "100%" }}
                                    value={lazyParams.filters.toDate.value}
                                    onChange={(e) => {
                                        setLazyParams({
                                            ...lazyParams,
                                            filters: {
                                                ...lazyParams.filters,
                                                toDate: {
                                                    ...lazyParams.filters.toDate,
                                                    value: e.value,
                                                },
                                            },
                                        });
                                    }}
                                    onBlur={() => {
                                        setFormatDateVal(dateFormat1);
                                    }}
                                    onFocus={() => {
                                        setFormatDateVal(dateFormat2);
                                    }}
                                    name="toDate"
                                    id="toDate"
                                    // maxDate={now}
                                    minDate={lazyParams.filters.fromDate.value}
                                    dateFormat={formatDateVal}
                                ></Calendar>
                                {/* <InputText
                                    style={{
                                        width: "100%",
                                    }}
                                    type="date"
                                    id="toDate"
                                    name="toDate"
                                    value={lazyParams.filters.toDate.value}
                                    max={now}
                                    min={lazyParams.filters.fromDate.value}
                                    onChange={(e) => {
                                        setCheckLoad(false);
                                        setLazyParams({
                                            ...lazyParams,
                                            filters: {
                                                ...lazyParams.filters,
                                                toDate: {
                                                    ...lazyParams.filters.toDate,
                                                    value: e.target.value,
                                                },
                                            },
                                        });
                                    }}
                                ></InputText> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-12 md:col-4 text-right" style={{ margin: "auto" }}>
                        <label
                            className="col-12 text-center"
                            style={{
                                width: "85px",
                                justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="toDate"
                        >
                            {" "}
                        </label>
                        <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                            <Button
                                label={t("search", { ns: "common" })}
                                icon="pi pi-search"
                                onClick={(e) => {
                                    if (lazyParams.filters.userName.value || lazyParams.filters.phoneNumber.value || lazyParams.filters.email.value) {
                                        setCheckLoad(true);
                                        setLazyParams({
                                            ...lazyParams,
                                            first: 0,
                                            page: 0,
                                        });
                                    } else {
                                        if (lazyParams.filters.fromDate.value && lazyParams.filters.toDate.value) {
                                            if (checkDateMonth(lazyParams.filters.fromDate.value, lazyParams.filters.toDate.value, range2)) {
                                                setCheckLoad(true);
                                                setLazyParams({
                                                    ...lazyParams,
                                                    first: 0,
                                                    page: 0,
                                                });
                                            } else {
                                                toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("history.rangeFromToDate"), life: 3000 });
                                            }
                                        } else {
                                            toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("history.requiredfromandtodate"), life: 3000 });
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const checkboxBodyTemplate = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center " style={{ margin: "auto" }}>
                <Checkbox checked={rowData.enabled} readOnly />
            </div>
        );
    };

    const typeTemplate = (rowData) => {
        return <div className="flex align-items-center justify-content-center actions">{types.find((e) => e.value === rowData.type)?.label}</div>;
    };
    const statusTemplate = (rowData) => {
        let text = "";
        if (rowData.level == 0 && rowData.state == 0) {
            text = "Tài khoản hoạt động ở mức 0";
        } else if (rowData.level == 1 && rowData.state == 1 && !rowData.isUpdate) {
            text = "Tài khoản chờ kích hoạt thiết bị - Trường hợp cần đổi mật khẩu";
        } else if (rowData.level == 1 && rowData.state == 1 && rowData.isUpdate) {
            text = "Tài khoản chờ kích hoạt thiết bị - Trường hợp không cần đổi mật khẩu";
        } else if (rowData.level == 1 && rowData.state == 2) {
            text = "Tài khoản hoạt động mức 1";
        } else if (rowData.level == 1 && rowData.state == 97) {
            text = "Tài khoản bị khóa tạm thời";
        } else if (rowData.level == 1 && rowData.state == 98) {
            text = "Tài khoản bị khóa tạm thời";
        } else if (rowData.level == 2 && rowData.state == 1 && !rowData.isUpdate) {
            text = "Tài khoản chờ kích hoạt thiết bị - Trường hợp cần đổi mật khẩu";
        } else if (rowData.level == 2 && rowData.state == 1 && rowData.isUpdate) {
            text = "Tài khoản chờ kích hoạt thiết bị - Trường hợp không cần đổi mật khẩu";
        } else if (rowData.level == 2 && rowData.state == 2) {
            text = "Tài khoản hoạt động mức 2";
        } else if (rowData.level == 2 && rowData.state == 97) {
            text = "Tài khoản bị khóa tạm thời";
        } else if (rowData.level == 2 && rowData.state == 98) {
            text = "Tài khoản bị khóa vĩnh viễn";
        }
        return <div className="flex align-items-center justify-content-center actions">{text}</div>;
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center actions" style={{ margin: "auto" }}>
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button mr-2"
                    tooltip={t("view", { ns: "common" })}
                    onClick={() => {
                        setAccountRegisterHistoryDetails([]);
                        getDetailInUserHistory(headers, rowData.id)
                            .then((res) => {
                                const data = Object.entries(res.data).map((x, y) => {
                                    let before = x[1]["before"];
                                    let after = x[1]["after"];
                                    let field = x[0];
                                    return { stt: y + 1, field: field, valueBefore: before.toString(), valueAfter: after?.toString() };
                                });
                                setAccountRegisterHistoryDetails(data);
                            })
                            .catch((e) => {
                                setAccountRegisterHistoryDetails([]);
                            });
                        setAccountRegisterHistoryDialog(true);
                    }}
                />
            </div>
        );
    };

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("history.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("history.list")}>
                                <Toast ref={toast} />
                                <DataTable
                                    ref={dt}
                                    value={accountRegisterHistories}
                                    dataKey="id"
                                    className="datatable-responsive p-datatable-sm"
                                    // globalFilter={globalFilter}
                                    // header={headerTemplate}
                                    showGridlines
                                    lazy
                                    paginator
                                    rows={lazyParams.rows}
                                    // rowsPerPageOptions={[10, 20, 50]}
                                    first={lazyParams.first}
                                    totalRecords={totalRecords}
                                    onPage={onPage}
                                    onSort={onSort}
                                    sortField={lazyParams.sortField}
                                    sortOrder={lazyParams.sortOrder}
                                    onFilter={onFilter}
                                    filters={lazyParams.filters}
                                    loading={loading}
                                    paginatorClassName="justify-content-start"
                                    paginatorTemplate={paginatorTemplate}
                                    emptyMessage="Không có dữ liệu"
                                    scrollable
                                >
                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                    <Column field="username" sortable header={t("history.username")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="fullName" header={t("history.fullName")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="phoneNumber" header={t("history.phoneNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="email" header={t("history.email")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="level" header={t("history.level")} style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="type" header={t("history.type")} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} body={typeTemplate} />
                                    <Column
                                        field="enabled"
                                        header={t("history.enabled")}
                                        body={checkboxBodyTemplate}
                                        style={{
                                            minWidth: "140px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "normal",
                                        }}
                                    />
                                    <Column field="cardExpireDate" header={t("history.cardExpireDate")} style={{ minWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column header={t("history.status")} body={statusTemplate} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="modifiedDate" header={t("history.modifiedDate")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column style={{ minWidth: "80px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} body={actionTemplate} />
                                </DataTable>
                            </BlockDetail>
                        </div>
                    </div>
                    <AccountRegisterHistoryDetail />
                </div>
            </div>
        </div>
    );
};
